export enum FacetGroupNamesFallback {
    distance = 'Distance from you',
    make_and_model = 'Make and model',
    price = 'Price',
    lease_price_and_terms = 'Price and terms',
    year = 'Year',
    gearbox = 'Gearbox',
    mileage = 'Mileage',
    body_type = 'Body type',
    fuel_type = 'Fuel type',
    battery_range = 'Battery range',
    charging_time = 'Charging time',
    home_charging_time = 'Home charging time',
    public_charging_time = 'Public charging time',
    previously_written_off = 'Previously written off',
    engine_size = 'Engine size',
    colour = 'Colour',
    keyword_search = 'Keyword search',
    seller_type = 'Private sellers',
    engine_power = 'Engine power',
    doors = 'Doors',
    seats = 'Seats',
    boot_space = 'Boot space',
    acceleration = 'Acceleration',
    tax_per_year = 'Tax per year',
    drive_type = 'Drive type',
    fuel_consumption = 'Fuel consumption',
    insurance_group = 'Insurance group',
    co2_emissions = 'CO2 emissions',
    with_digital_retailing = 'Reserve with Autotrader',
    wheelchair_accessible = 'Wheelchair accessible',
    ni_only = 'N. Ireland adverts only',
    manufacturer_approved = 'Manufacturer approved',
    frame_size_cm = 'Frame size (cm)',
    wheelbase = 'Wheelbase',
    cab_type = 'Cab type',
    vat_status = 'VAT status',
    axle_config = 'Axle config',
    gross_vehicle_weight = 'Gross vehicle weight',
    gross_trailer_weight = 'Gross trailer weight',
    emission_class = 'Emission class',
    driver_position = 'Driver position',
    hours_used = 'Hours used',
    trailer_axle_number = 'Axles',
    berth = 'Berth',
    style = 'Category',
    bedroom_layout = 'Bedroom layout',
    end_layout = 'End layout',
    mtplm = 'MTPLM',
    exterior_length = 'Length',
    category_tag = 'Search by car type',
}
